import {
  EMAIL_SCHEMA,
  moduleNamespace,
  NAME_SCHEMA,
  PASSWORD_SCHEMA,
  SET_AGENCY_PRICE_FROM_RESPONSE,
  SET_CONFIGURATION,
  SET_EMAIL,
  SET_ERRORS,
  SET_LAYOUT,
  SET_NAME,
  SET_OPERATION_COUNTRY,
  SET_ORGANISATION_ID,
  SET_PASSWORD,
  SET_PRICE_FROM_RESPONSE,
  SET_STAGE,
  SET_STRIPE_PAYMENT_METHOD_ID
} from "./constants";
import {writeSession} from "../sharedGlobal";
import {getOperationCountrySchema, writeConfigurationToSession} from "./methods";

export default {
  [SET_CONFIGURATION](state, payload) {
    state.configuration = payload;
    writeConfigurationToSession(payload);
  },
  [SET_LAYOUT](state, payload) {
    state.layout = payload;
  },
  [SET_NAME](state, payload) {
    delete state.errors.name;
    const { error } = NAME_SCHEMA.validate(payload);

    if (error) {
      state.errors = {
        name: error.details,
        ...state.errors,
      };
    }

    state.name = payload;
    writeSession(moduleNamespace, 'name', payload);
  },
  [SET_EMAIL](state, payload) {
    delete state.errors.email;
    const { error } = EMAIL_SCHEMA.validate(payload);

    if (error) {
      state.errors = {
        email: error.details,
        ...state.errors,
      };
    }

    state.email = payload;
    writeSession(moduleNamespace, 'email', payload);
  },
  [SET_PASSWORD](state, payload) {
    delete state.errors.password;
    const { error } = PASSWORD_SCHEMA.validate(payload);

    if (error) {
      state.errors = {
        password: error.details,
        ...state.errors,
      };
    }

    state.password = payload;
  },
  [SET_OPERATION_COUNTRY](state, payload) {
    const { value, countries } = payload;
    delete state.errors.operationCountry;
    const { error } = getOperationCountrySchema(countries).validate(value);

    if (error) {
      state.errors = {
        operationCountry: error.details,
        ...state.errors,
      };
    }

    state.operationCountry = value;
    writeSession(moduleNamespace, 'operationCountry', value);
  },
  [SET_ERRORS](state, payload) {
    state.errors = payload;
  },
  [SET_STAGE](state, payload) {
    state.stage = payload;
  },
  [SET_PRICE_FROM_RESPONSE](state, payload) {
    state.discountMetaData = null; // Assume no discount info available

    const {
      message,
      currency,
      billing_period: billingPeriod,
      show_tax: showTax,
      full_price: fullPrice,
      monthly_cost_comparison: monthlyCostComparison,
      ...data
    } = payload;

    let priceWithDiscount = {
      currency,
      billingPeriod,
      showTax,
      fullPrice: {
        exVat: fullPrice.ex_vat,
        incVat: fullPrice.inc_vat,
        exVatDisplay: fullPrice.ex_vat_display,
        incVatDisplay: fullPrice.inc_vat_display,
      },
      monthlyCostComparison,
    };

    if (data && data.discounted) {
      const {
        ex_vat: exVat,
        inc_vat: incVat,
        ex_vat_display: exVatDisplay,
        inc_vat_display: incVatDisplay,
        ...metaData
      } = data.discounted;

      if (exVat && incVat) {
        priceWithDiscount = {
          ...priceWithDiscount,
          discount: {
            exVat,
            incVat,
            exVatDisplay,
            incVatDisplay,
          }
        };
      }

      state.discountMetaData = metaData;
    }


    state.price = priceWithDiscount;
  },
  [SET_AGENCY_PRICE_FROM_RESPONSE](state, payload) {
    const {
      message,
      currency,
      billing_period: billingPeriod,
      show_tax: showTax,
      full_price: fullPrice,
      ...data
    } = payload;

    state.price = {
      currency,
      billingPeriod,
      showTax,
      fullPrice: {
        exVat: fullPrice.ex_vat,
        incVat: fullPrice.inc_vat,
        exVatDisplay: fullPrice.ex_vat_display,
        incVatDisplay: fullPrice.inc_vat_display,
      },
    };
  },
  [SET_STRIPE_PAYMENT_METHOD_ID](state, payload) {
    state.stripePaymentMethodId = payload;
    writeSession(moduleNamespace, 'stripePaymentMethodId', payload);
  },
  [SET_ORGANISATION_ID](state, payload) {
    state.registrationId = payload;
    writeSession(moduleNamespace, 'registrationId', payload);
  },
};
